import React, { useEffect } from "react";
import { useNavContext } from "../../context-api/nav-context";
import PostcodeForm from "../../components/quote-components/quoteQuestions/PostcodeForm";

const Postcode = () => {
  const { closeNavbarMenu } = useNavContext();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div
      className="section section-wrapper postcode-section"
      onMouseOver={closeNavbarMenu}
    >
      <div className="question-heading">
        <h2 className="title postcode-title">
          Finally, enter the first part of your post code
        </h2>
      </div>
      <PostcodeForm />
    </div>
  );
};

export default Postcode;
